import { HttpParams } from "@angular/common/http";
import { ICriteria } from "../services/criteria.interface";

export class LookupCriteria implements ICriteria {
  pageSize: number = 10;
  page: number = 1;
  orderby: string = 'Id asc';

  paramsExport(): HttpParams {
    let params = new HttpParams()
      .set('page', String(this.page))
      .set('orderby', this.orderby)
      .set('pageSize', String(this.pageSize));

    return params;
  }
}
